// Wraps image URLs from CDNs that some networks/extensions block (notably
// images.unsplash.com) through our own backend image proxy so the browser
// only ever fetches from our domain. Pass through any other URL unchanged.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PROXIED_HOSTS = new Set([
  'images.unsplash.com',
  'plus.unsplash.com',
  'source.unsplash.com',
]);

export function proxiedImage(url) {
  if (!url || typeof url !== 'string') return url;
  // Skip if we have no backend URL or the URL is already a relative path.
  if (!BACKEND || url.startsWith('/') || url.startsWith('data:')) return url;
  try {
    const u = new URL(url);
    if (PROXIED_HOSTS.has(u.hostname)) {
      return `${BACKEND}/api/image-proxy?url=${encodeURIComponent(url)}`;
    }
  } catch {
    // Invalid URL, return as-is.
  }
  return url;
}
